/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 20, height = 20 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
    <path d="M14.9998 1.66699L18.3332 5.00033M14.1665 5.83366L16.6665 3.33366M15.8332 7.50033L7.24984 16.0837C6.4165 16.917 5.1665 16.917 4.4165 16.0837L3.9165 15.5837C3.08317 14.7503 3.08317 13.5003 3.9165 12.7503L12.4998 4.16699M7.49984 9.16699L10.8332 12.5003M4.1665 15.8337L1.6665 18.3337M11.6665 3.33366L16.6665 8.33366" stroke="#262626" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
